import { Outlet } from 'react-router-dom';

import { useIsSelectBoat } from '@/entities/boat';
import { Header } from '@/widgets/header';
import { Sidebar } from '@/widgets/sidebar';

export const AppLayout = ({ withSidebar = false }: { withSidebar?: boolean }) => {
	// Sidebar items are pages of a yacht, so without a selected yacht it has nothing to show
	const isSelectBoat = useIsSelectBoat();

	return (
		<div className="flex h-screen flex-col">
			<Header />
			<div className="flex min-h-0 flex-1 pt-6">
				{withSidebar && isSelectBoat && <Sidebar />}
				<div className="flex min-w-0 flex-1 flex-col">
					<Outlet />
				</div>
			</div>
		</div>
	);
};
